<template>
  <div class="main" id="main">
    <div class="main__container">
      <div class="main__text-block">
        <h1>Transform Your Idea Into Reality with Finsweet</h1>
        <p>
          The entire Finsweet team knows what's good with Webflow and you can
          too with 1 week and a good attitude.
        </p>
        <div class="main__btn">
          <div class="main__btn__texture">
            <img src="@/assets/img/main/btn-texture.svg" alt="" />
          </div>
          <p>Request Quote</p>
          <svg
            width="21"
            height="8"
            viewBox="0 0 21 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.3536 4.35355C20.5488 4.15829 20.5488 3.84171 20.3536 3.64645L17.1716 0.464466C16.9763 0.269204 16.6597 0.269204 16.4645 0.464466C16.2692 0.659728 16.2692 0.976311 16.4645 1.17157L19.2929 4L16.4645 6.82843C16.2692 7.02369 16.2692 7.34027 16.4645 7.53553C16.6597 7.7308 16.9763 7.7308 17.1716 7.53553L20.3536 4.35355ZM0 4.5L20 4.5V3.5L0 3.5L0 4.5Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
      <div class="main__img">
        <img src="@/assets/img/main/main-img.webp" alt="team" />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>